import * as React from 'react';
import { Component } from 'react';
import { isEqual } from 'lodash';
import { Swiper } from '@wmfe/mach-pro-components-react';
import lx from '@pages/order/order_confirm_golden/statistics';
import { UserGetMode } from '../../../utils/constant';
import TrackUtils from '../../../utils/TrackUtils';
import './index.css';

interface PickupTagProps {
  isShopPage?: boolean; // 是否是门店页
  shopId?: string; // 门店页自取MV上报需要shopId
  pickupTagLocationInfo?: {
    x: number;
    y: number;
    width: number;
  };
  customStyle?: any; // 自定义样式 门店页/提单页有不同的样式
  pickupLabelList: {
    pickupLabelType: number;
    pickupLabelInfo: string;
  }[];
}

interface PickupTagState {
  isReady: boolean;
  swiperWidth: number;
}

class PickupTag extends Component<PickupTagProps, PickupTagState> {
  reportedIndices: Set<number> = new Set();
  swiperView: any = null;

  constructor(props: PickupTagProps) {
    super(props);
    this.state = {
      isReady: false,
      swiperWidth: 50, // 默认最小宽度
    };
  }

  componentDidMount() {
    const swiperWidth = this.getMaxLabelWidth();
    this.setState({ swiperWidth, isReady: true });
  }

  componentDidUpdate(prevProps: PickupTagProps) {
    const { pickupLabelList } = this.props;
    const isDataChanged = !isEqual(prevProps.pickupLabelList, pickupLabelList);
    // 数据变化时重新计算swiper宽度, 并刷新轮播组件(https://km.sankuai.com/collabpage/826708792)
    if (isDataChanged) {
      const swiperWidth = this.getMaxLabelWidth();
      this.setState({ swiperWidth }, () => {
        this.swiperView?.reload?.(); // 刷新轮播组件，数据更新时必须调用 reload 刷新组件使数据生效
      });
    }
  }

  // 计算 文案(pickupLabelInfo)宽度
  widthForText = (text: string) => {
    if (!text?.length) {
      return 0;
    }
    const SLCommon = Mach.requireModule('SLCommon');
    const titleTextWidth = SLCommon.widthForText({
      content: text,
      fontSize: 12,
      fontFamily: 'KeeTa-Regular',
    });
    return titleTextWidth;
  };

  // 计算 swiper 宽度
  getMaxLabelWidth = () => {
    const { pickupLabelList } = this.props;
    let maxWidth = 50; // 最小宽度50
    pickupLabelList.forEach((label) => {
      const width = Number(this.widthForText(label.pickupLabelInfo as string)) + 6 * 2; // 计算文案宽度 + padding
      if (width > maxWidth) {
        maxWidth = width;
      }
    });
    return Math.min(maxWidth, 150); // 最大宽度为150
  };

  renderItem = (cellInfo: any) => {
    const { pickupLabelList } = this.props;
    const { swiperWidth } = this.state;
    const item = pickupLabelList[cellInfo.index];
    return (
      <view className="swiper-item" style={{ width: swiperWidth }}>
        <text className="pickup-tag-text">{item.pickupLabelInfo}</text>
      </view>
    );
  };

  itemCount = () => this.props.pickupLabelList.length;

  onDidScrollToItem = (index: number) => {
    const { pickupLabelList, shopId } = this.props;
    if (!this.reportedIndices.has(index)) {
      const item = pickupLabelList[index];
      const { pickupLabelType } = item;
      // 上报自取标签曝光
      const userGetMode = UserGetMode.pickup;
      // 区分门店页/提单页 其中门店页需要shopId
      if (shopId) {
        // 门店页自取MV上报
        TrackUtils.reportUserModeMV(userGetMode, shopId, pickupLabelType);
      } else {
        lx.clickTabMv({
          user_get_mode: UserGetMode.pickup,
          pickup_label_type: pickupLabelType,
        });
      }
      this.reportedIndices.add(index);
    }
  };

  render() {
    const {
      isShopPage, pickupTagLocationInfo, pickupLabelList, customStyle
    } = this.props;
    let curCustomStyle = customStyle || {};
    const { isReady, swiperWidth } = this.state;

    if (!pickupLabelList || pickupLabelList.length === 0) {
      return null;
    }
    if (isShopPage && !(pickupTagLocationInfo?.x)) {
      return null;
    }

    if (!isReady) {
      return null; // 在确认宽度之前不展示组件
    }

    // itemCount 大于1时才轮播
    const autoPlay = pickupLabelList.length > 1;

    // 如果是门店页 则根据PickupTagLocationInfo 计算上方PickupTag居中的位置 并设置customStyle
    if (isShopPage) {
      const pickupTagTop = pickupTagLocationInfo?.y ? pickupTagLocationInfo.y - 19 : 0; // 23-4 23为本组件高度 4为间距
      const pickupTagLeft = pickupTagLocationInfo?.x
        ? pickupTagLocationInfo.x + (pickupTagLocationInfo.width - swiperWidth) / 2
        : 0;

      curCustomStyle = {
        top: pickupTagTop,
        left: pickupTagLeft,
        width: swiperWidth,
      };
    }

    return (
      <view className="pickup-tag-container" style={curCustomStyle}>
        <view className="pickup-tag-wrapper">
          <view className="swiper-container" style={{ width: swiperWidth }}>
            <Swiper
              ref={(ref: any) => { this.swiperView = ref; }}
              direction="vertical"
              itemCount={this.itemCount}
              renderItem={this.renderItem}
              autoPlay={autoPlay}
              infinite
              interval={2000}
              scrollable={false}
              onDidScrollToItem={this.onDidScrollToItem}
            />
          </view>
          <image className="pickup-tag-img" src="assets://shop/pickup_tag_arrow.png" />
        </view>
      </view>
    );
  }
}

export default PickupTag;
